<template>
    <div>
        <accordion :class="{ 'disable-pointer-events': !expanded }">
            <accordion-item
                :force-active="expanded"
                :disable-toggle="true"
                class="mb-4"
            >
                <!-- This slot will handle the title/header of the accordion and is the part you click on -->
                <template slot="accordion-trigger">
                    <span class="number">2</span>
                    <h4>pagamento</h4>
                </template>
                <!-- This slot will handle all the content that is passed to the accordion -->
                <template slot="accordion-content">
                    <form class="checkout-form">
                        <div class="form-group input-container">
                            <label class="font-body"> promocode </label>

                            <div class="input-box">
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="promocode"
                                    placeholder="Promocode"
                                    :disabled="this.validPromocode"
                                />
                                <button
                                    class="btn-promocode"
                                    v-if="!this.validPromocode"
                                    @click="validatePromoCode"
                                >
                                    Aplicar
                                </button>
                                <button
                                    v-if="this.validPromocode"
                                    class="btn-promocode"
                                    @click="clearPromoCode"
                                >
                                    Limpar
                                </button>
                            </div>
                            <span
                                class="text-danger text-sm"
                                v-if="
                                    promocodeError.promocode ||
                                        paymentFormError.promocode
                                "
                            >
                                {{
                                    promocodeError.promocode[0] ||
                                        paymentFormError.promocode[0]
                                }}
                            </span>
                            <p
                                class="text-dark text-sm pt-2 pl-1"
                                v-if="validPromocode"
                            >
                                {{ validPromocodeMsg ? validPromocodeMsg : "" }}
                            </p>
                        </div>
                        <div class="mt-6 mb-6">
                            <label class="font-body">
                                método de pagamento*
                            </label>
                            <ul
                                class="grid grid-flow-row grid-cols-1 gap-3 radio-selector"
                            >
                                <li
                                    class="radio-container radio-container-checkout-override"
                                >
                                    <input
                                        type="radio"
                                        name="radio_payment"
                                        id="mbway"
                                        v-model="payment_method"
                                        value="5"
                                        :disabled="!valid_payment_methods.includes(5) && valid_payment_methods.length !== 0"
                                    />
                                    <label class="container" for="mbway">
                                        <p>MB Way</p>
                                        <span class="checkmark"></span>
                                    </label>
                                </li>

                                <li
                                    class="radio-container radio-container-checkout-override"
                                >
                                    <input
                                        type="radio"
                                        name="radio_payment"
                                        id="money"
                                        v-model="payment_method"
                                        value="2"
                                        :disabled="!valid_payment_methods.includes(2) && valid_payment_methods.length !== 0"
                                    />
                                    <label class="container" for="money">
                                        <p>Dinheiro</p>
                                        <span class="checkmark"></span>
                                    </label>
                                </li>
                                <li
                                    class="radio-container radio-container-checkout-override"
                                >
                                    <input
                                        type="radio"
                                        name="radio_payment"
                                        id="multibanco"
                                        v-model="payment_method"
                                        value="1"
                                        :disabled="!valid_payment_methods.includes(1) && valid_payment_methods.length !== 0"
                                    />
                                    <label class="container" for="multibanco">
                                        <p>Multibanco</p>
                                        <span class="checkmark"></span>
                                    </label>
                                </li>
                                <li
                                    class="radio-container radio-container-checkout-override"
                                >
                                    <input
                                        type="radio"
                                        name="radio_payment"
                                        id="creditcard"
                                        v-model="payment_method"
                                        value="6"
                                        :disabled="!valid_payment_methods.includes(6) && valid_payment_methods.length !== 0"
                                    />
                                    <label class="container" for="creditcard">
                                        <p
                                            class="whitespace-nowrap overflow-hidden overflow-ellipsis"
                                        >
                                            Cartão de Crédito/Débito
                                        </p>
                                        <span class="checkmark"></span>
                                    </label>
                                </li>
                            </ul>
                        </div>

                        <div
                            class="form-group input-container"
                            :class="{ hidden: payment_method != '2' }"
                        >
                            <label class="font-body">
                                Vou pagar com (€):*
                            </label>

                            <div class="input-box">
                                <input
                                    type="text"
                                    v-model="change_for"
                                    placeholder="Vou pagar com (€):"
                                />
                            </div>
                            <span
                                class="text-danger error"
                                v-if="paymentFormError.change_for"
                                >{{ paymentFormError.change_for[0] }}</span
                            >
                        </div>

                        <div class="mt-6" v-if="mbWayPromo">
                            <p class="text-gray text-body">
                                {{ mbWayPromo }}
                            </p>
                        </div>

                        <div
                            class="mt-6"
                            :class="{ hidden: payment_method != '6' }"
                        >
                            <p class="text-gray text-body">
                                Após confirmares o teu pedido, irás ser
                                redirecionado para uma página onde poderás
                                colocar os dados do teu cartão de crédito.
                            </p>
                        </div>

                        <div
                            class="mt-6 input-container phone-field"
                            :class="{ hidden: payment_method != '5' }"
                        >
                            <label>número telefone*</label>
                            <phone-mask
                                :is-form="true"
                                @clearField="customerMbwayPhoneNumber = null"
                                :default-country-code="
                                    customerMbwayPhoneCountryCode
                                "
                                v-model="phone"
                                :default-phone-number="customerMbwayPhoneNumber"
                            >
                            </phone-mask>
                            <span
                                class="text-danger error"
                                v-if="paymentFormError.mbway_phone"
                                >{{ paymentFormError.mbway_phone[0] }}</span
                            >
                        </div>
                        <div class="mt-6">
                            <label class="font-body"> dados na fatura* </label>
                            <ul
                                class="grid grid-flow-row grid-cols-2 gap-3 radio-selector"
                            >
                                <li class="radio-container">
                                    <input
                                        type="radio"
                                        name="radio_billing"
                                        id="nif-yes"
                                        v-model="with_billing"
                                        value="yes"
                                    />
                                    <label class="container" for="nif-yes">
                                        <p>Sim</p>
                                        <span class="checkmark"></span>
                                    </label>
                                </li>
                                <li class="radio-container">
                                    <input
                                        type="radio"
                                        name="radio_billing"
                                        id="nif-no"
                                        v-model="with_billing"
                                        value="no"
                                    />
                                    <label class="container" for="nif-no">
                                        <p>Não</p>
                                        <span class="checkmark"></span>
                                    </label>
                                </li>
                            </ul>
                            <div
                                class="flex mt-6"
                                :class="{ hidden: with_billing == 'no' }"
                            >
                                <div class="form-group input-container pr-3.5">
                                    <label class="font-body">
                                        nome na fatura*
                                    </label>

                                    <div class="input-box">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="billing_name"
                                            placeholder="Nome"
                                        />
                                        <span
                                            class="text-danger error"
                                            v-if="paymentFormError.billing_name"
                                            >{{
                                                paymentFormError.billing_name[0]
                                            }}</span
                                        >
                                    </div>
                                </div>
                                <div class="form-group input-container">
                                    <label class="font-body"> NIF* </label>

                                    <div class="input-box">
                                        <input
                                            type="text"
                                            class="form-control"
                                            v-model="nif"
                                            placeholder="NIF"
                                        />
                                        <span
                                            class="text-danger error"
                                            v-if="paymentFormError.nif"
                                            >{{ paymentFormError.nif[0] }}</span
                                        >
                                    </div>
                                </div>
                            </div>

                            <div class="flex mt-6">
                                <div class="form-group input-container pr-3.5 flex items-start">
                                    <input type="checkbox" id="terms" :checked="mktOptin" v-model="mkt_optin" />
                                    <label for="terms" class="normal-case ml-2">
                                        Autorizo o tratamento dos meus dados para receber comunicações de marketing, campanhas promocionais e ofertas personalizadas por e-mail e telefone.
                                    </label>
                                </div>
                            </div>

                            <p class="mt-6 mb-3 text-info">
                                *campos obrigatórios
                            </p>

                            <button
                                class="btn-bg"
                                type="button"
                                @click="handlePaymentRequest"
                                :class="{ disabled: isLoading }"
                            >
                                Finalizar pedido
                            </button>
                        </div>
                    </form>
                </template>
            </accordion-item>
        </accordion>

        <card-payment-modal
            v-if="cardPaymentVisible"
            @close="cardPaymentVisible = false"
            :action-url="ccCallbackUrl"
        >
        </card-payment-modal>

        <modal-checkout-validate-confirm
            :show-modal="showModalAlert"
            @close-modal-promocode="closeModalPromocode"
        ></modal-checkout-validate-confirm>
    </div>
</template>

<script>
import {
    VsaList,
    VsaItem,
    VsaHeading,
    VsaContent,
    VsaIcon
} from "vue-simple-accordion";
import Accordion from "./accordion";
import AccordionItem from "./accordion-item";
import ModalCheckoutValidateConfirm from "./modal-checkout-validate-confirm";

export default {
    // ...
    components: {
        VsaList,
        VsaItem,
        VsaHeading,
        VsaContent,
        VsaIcon,
        Accordion,
        AccordionItem,
        ModalCheckoutValidateConfirm
    },
    props: {
        orderType: {
            required: false
        },
        customerNif: {
            required: false
        },
        customerPromocode: {
            required: false
        },
        customerName: {
            required: false
        },
        customerMbwayPhoneCode: {
            required: false
        },
        customerMbwayPhoneNumber: {
            required: false
        },
        customerMbwayPhoneCountryCode: {
            required: false
        },
        ccFormUrl: {
            required: false
        },
        ccCallbackUrl: {
            required: true
        },
        mbwayEnable: {
            required: true,
            default: true
        },
        multibancoEnable: {
            required: true,
            default: true
        },
        moneyEnable: {
            required: true,
            default: true
        },
        ccEnable: {
            required: true,
            default: true
        },
        defaultPaymentMethod: {
            required: true,
            default: ""
        },
        mktOptin: {
            required: true,
            default: false
        }
    },
    watch: {
        payment_method: function(method) {
            if (method == "5") {
                this.requestMbWayPromo();
            } else {
                this.mbWayPromo = false;
            }

            this.paymentMethodEvent();
        },

        promocode: function() {
            this.promocodeWasValidated = false;
            this.validPromocode = false;
        }
    },
    data() {
        return {
            expanded: false,
            validPromocode: this.customerPromocode ? true : false,
            validPromocodeMsg: false,
            promocode: this.customerPromocode,
            paymentFormError: {},
            promocodeError: {},
            promocodeWasValidated: false,
            payment_method: "",
            valid_payment_methods: [],
            phone: "",
            change_for: "",
            with_billing: "yes",
            nif: this.customerNif,
            billing_name: this.customerName,
            cardPaymentVisible: false,
            isLoading: false,
            mbWayPromo: false,
            showModalAlert: false,
            mkt_optin: this.mktOptin ? true : false,
        };
    },
    created() {
        this.$root.$on("open-accordion-payment", slot => {
            this.valid_payment_methods = slot.payment_methods;
            this.payment_method = this.valid_payment_methods[0] ?? '';
            this.expanded = true;
        });

        this.$root.$on("close-accordion-payment", () => {
            this.expanded = false;
        });
    },
    mounted() {
        if (this.payment_method == "5") {
            this.requestMbWayPromo();
        }

        if (this.payment_method) {
            this.paymentMethodEvent();
        }

        this.payment_method = this.defaultPaymentMethod;
    },
    methods: {
        handlePaymentRequest() {
            if (
                this.promocode !== false &&
                this.promocode !== "" &&
                this.promocodeWasValidated === false &&
                !this.validPromocode
            ) {
                this.showModalAlert = true;
                return;
            }

            let payload = {
                promocode: this.promocode,
                payment_method: this.payment_method,
                mbway_phonecode:
                    (this.phone && this.phone.countryCallingCode) ||
                    this.customerMbwayPhoneCode,
                mbway_phone:
                    (this.phone && this.phone.nationalNumber) ||
                    this.customerMbwayPhoneNumber,
                change_for: this.change_for,
                with_billing: this.with_billing == "yes",
                mkt_optin: this.mkt_optin
            };

            //do not send billing_name and nif when with_billing is false
            if (this.with_billing == "yes") {
                payload.billing_name = this.billing_name;
                payload.nif = this.nif;
            }

            this.isLoading = true;
            this.$axios
                .post("/checkout/payment", payload)
                .then(response => {
                    if (
                        this.payment_method == "1" ||
                        this.payment_method == "2"
                    ) {
                        Livewire.emit("redirectPaymentSuccess");
                    } else if (this.payment_method == "5") {
                        this.isLoading = false;
                        this.$root.$emit(
                            "display-modal-mbway-payment",
                            response.data.code
                        );
                    } else {
                        this.isLoading = false;
                        document.getElementById(
                            "card-payment-checkout-id"
                        ).src = this.ccFormUrl + response.data.checkoutId;
                        this.cardPaymentVisible = true;
                        this.$root.$emit("display-modal-card-payment");
                    }
                })
                .catch(error => {
                    switch (error.response.status) {
                        case 422:
                            this.paymentFormError = error.response.data;
                            this.isLoading = false;
                            break;
                        case 400:
                            this.$root.$emit(
                                "display-modal-error-payment",
                                error.response.data.data.message
                            );
                            this.isLoading = false;
                            Livewire.emit("refreshOrderSummary");
                            this.validPromocode = false;
                            this.promocode = "";
                            break;
                        default:
                            //if error 500 => generic error
                            this.$root.$emit("display-modal-error-payment");
                            this.isLoading = false;
                            break;
                    }
                });
        },
        requestMbWayPromo() {
            this.$axios
                .get("/mb-way/campaign")
                .then(response => {
                    if (response.data.message && response.data.message != "") {
                        this.mbWayPromo = response.data.message;
                    } else {
                        this.mbWayPromo = false;
                    }
                })
                .catch(error => {
                    this.mbWayPromo = false;
                    console.log(error);
                });
        },
        clearPromoCode(e) {
            e.preventDefault();
            this.promocode = "";
            this.validPromocode = false;
            this.promocodeError = {};
            this.validPromocodeMsg = "";
            Livewire.emit("removeCheckoutDiscount");
        },
        validatePromoCode(e) {
            e.preventDefault();

            this.$axios
                .post("/promocode/validate", { promocode: this.promocode })
                .then(response => {
                    this.validPromocode = true;
                    this.promocodeError = {};
                    this.validPromocodeMsg =
                        response.data.scope == "offers"
                            ? "Oferta Adicionada: " +
                              response.data.product_offers.toString()
                            : "Código Aplicado";
                    Livewire.emit("applyCheckoutDiscountIfAvailable");
                })
                .catch(error => {
                    switch (error.response.status) {
                        case 422:
                            this.promocodeError = error.response.data;
                            break;
                        case 404:
                            this.promocodeError = error.response.data;
                            break;
                        default:
                            this.$root.$emit("display-modal-error-payment");
                            break;
                    }
                });
            this.promocodeWasValidated = true;
        },
        paymentMethodEvent() {
            this.$axios.get(`/api/event/paymentMethod`).catch(error => {
                console.log(error);
            });
        },

        closeModalPromocode() {
            this.showModalAlert = false;
        }
    }
};
</script>
